import { CORE_API_HOSTNAME } from "config/envConfig";

import LocalStorage from "../../../utils/LocalStorage";
import APIService from "../index";

const coreAPIInstance = APIService({
  baseURL: CORE_API_HOSTNAME,
});

coreAPIInstance.interceptors.request.use((config) => {
  config.headers["Authorization"] = LocalStorage.getItem("authToken");

  return config;
});

export default coreAPIInstance;
